import { db } from "@/firebaseConfig";

const subCategoriesCollection = db.collection("sub_categories");

const saveSubCategory = async data => {
  subCategoriesCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("SubCategory successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateSubCategory = async (id, data) => {
  subCategoriesCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("SubCategory successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteSubCategory = async id => {
  subCategoriesCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("SubCategory successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getSubCategoryById = async id => {
  return subCategoriesCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  subCategoriesCollection,
  saveSubCategory,
  updateSubCategory,
  deleteSubCategory,
  getSubCategoryById
};
